export class CONSTANTS {
  private static baseUrl: string = "https://aiddevs.com/"
  static privacyStatement: string = this.baseUrl + "datenschutzerklaerung-software/"
  static imprint: string = this.baseUrl + "impressum/"
  static licenses: string = "/assets/3rdpartylicenses.txt"
  static termsAndConditions: string = this.baseUrl + "agbs/"
  static supportEmail: string = "mailto:support@neodiary.app?subject=Klinikportal"

  public static httpInterceptorExceptions: string[] = []

  static loginError: string = 'Ungültige Logindaten. Bitte überprüfe deinen Benutzernamen und dein Passwort.'
  static resetPasswordError: string = 'Ungültige Eingabe. Es existiert kein Konto mit der angegebenen E-Mail-Adresse.'
  static unauthenticatedError: string = 'Unauthorisierter Zugriff. Du wurdest automatisch ausgeloggt.'
  static forbiddenError: string = 'Der Zugang zum Klinikportal wurde deaktiviert.'
  static unknownError: string = 'Es ist ein unbekannter Fehler aufgetreten.'
  static connectionError: string = 'Verbindung zum Server fehlgeschlagen. Bitte prüfe deine Internetverbindung oder versuche es später erneut.'
  static serviceUnavailableError: string = 'Der Dienst ist aktuell nicht erreichbar. Bitte versuche es in wenigen Minuten erneut.'
  static passwordAuthFailedMessage: string = 'Authentifizierungstoken abgelaufen oder fehlerhaft.'
  static resourceMissingMessage: string = 'Die angeforderte Ressource existiert nicht.'
  static fileSizeExceededError: string = 'Die Datei ist zu groß.'
  static saveSuccessMessage: string = 'Änderungen erfolgreich gespeichert.'
  static saveErrorMessage: string = 'Beim Speichern ist ein Fehler aufgetreten. Bitte versuche es erneut.'

  static maxInput: number = 500
}
